// @flow
import React, { Component } from 'react';
import { View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { Icon } from '../common';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import { getStyles } from './styles';

export default class DeliveryMethod extends Component<Props> {
  styles = getStyles();

  getTitle() {
    if (this.props.deliveryMethod.type) {
      let title = I18n.t('SignUp.ConfirmPlan.deliveryMethod', {
        method: I18n.t(`SignUp.DeliveryMethod.methods.${this.props.deliveryMethod.type}.title`).toUpperCase(),
      });
      if (this.props.deliveryMethod.price != null) {
        title += ` - ${
          this.props.deliveryMethod.price !== 0 ? I18n.toPrice(this.props.deliveryMethod.price) : I18n.t('prices.free')
        }`;
      }
      return title;
    } else {
      let type;
      if (this.props.deliveryMethod) {
        switch (this.props.deliveryMethod.id) {
          case 'STANDARD_DELIVERY':
            type = 'STANDARD';
            break;
          case 'PREMIUM_DELIVERY':
          case 'EXPRESS_DELIVERY':
            type = 'PREMIUM';
            break;
          default:
            type = null;
        }
      }
      if (type) {
        return I18n.t('SignUp.ConfirmPlan.deliveryMethod', {
          method: I18n.t(`SignUp.DeliveryMethod.methods.${type}.title`).toUpperCase(),
        });
      }
    }

    return I18n.t('SignUp.DeliveryMethod.noDeliveryType');
  }

  render() {
    const title = this.getTitle();

    let textTitle;
    if (this.props.deliveryMethod.type) {
      textTitle = [
        <Text key={'methodTitle'} style={[this.styles.text, this.props.neutralColors && this.styles.neutralText]}>
          {title}
        </Text>,
        <Text
          key={'methodDescription'}
          style={[this.styles.legend, this.props.neutralColors && this.styles.neutralLegend]}
        >
          {I18n.t(`SignUp.DeliveryMethod.methods.${this.props.deliveryMethod.type}.description`, {
            duration: this.props.deliveryMethod.duration,
          })}
        </Text>,
      ];
    } else {
      textTitle = <Text style={[this.styles.text, this.props.neutralColors && this.styles.neutralText]}>{title}</Text>;
    }

    return (
      <View style={[this.styles.container, this.props.style]}>
        <Icon name="clock" color={this.props.neutralColors ? theme.gray.light : theme.transparentIconColor} size={26} />
        <View style={this.styles.textContainer}>{textTitle}</View>
      </View>
    );
  }
}

type Props = {
  deliveryMethod: any,
  neutralColors?: boolean,
  style?: any,
};
